import { TrophyIcon, StarIcon } from 'lucide-react';
import type { UserStats } from '@/types/database.types';
import { getRankColor } from '@/utils/user';

interface StatsGridProps {
  stats: UserStats;
}

export default function StatsGrid({ stats }: StatsGridProps) {
  return (
    <div className="px-8 py-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Rank Card */}
        <div className="bg-gray-50 rounded-lg p-6">
          <div className="flex items-center">
            <TrophyIcon className={`h-8 w-8 mr-3 ${getRankColor(stats.rank)}`} />
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Rank</h3>
              <p className={`text-xl font-bold ${getRankColor(stats.rank)}`}>
                {stats.rank}
              </p>
            </div>
          </div>
        </div>

        {/* Activity Score Card */}
        <div className="bg-gray-50 rounded-lg p-6">
          <div className="flex items-center">
            <StarIcon className="h-8 w-8 mr-3 text-yellow-500" />
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Activity Score</h3>
              <p className="text-xl font-bold text-yellow-500">
                {stats.activityScore} pts
              </p>
            </div>
          </div>
        </div>

        {/* SNAPs Created Card */}
        <div className="bg-gray-50 rounded-lg p-6">
          <div className="flex items-center">
            <TrophyIcon className="h-8 w-8 mr-3 text-primary-600" />
            <div>
              <h3 className="text-lg font-semibold text-gray-900">SNAPs Created</h3>
              <p className="text-xl font-bold text-primary-600">
                {stats.snapsCreated}
              </p>
            </div>
          </div>
        </div>

        {/* Comments Made Card */}
        <div className="bg-gray-50 rounded-lg p-6">
          <div className="flex items-center">
            <StarIcon className="h-8 w-8 mr-3 text-blue-600" />
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Comments</h3>
              <p className="text-xl font-bold text-blue-600">
                {stats.commentsMade}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}